import { FC } from 'react';

export const IconDataBase: FC = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="19" height="19" rx="9.5" fill="white" />
      <g clipPath="url(#clip0_1312_5497)">
        <path
          d="M12.875 8.5625V9.6875C12.875 10.6194 11.3638 11.375 9.5 11.375C7.63625 11.375 6.125 10.6194 6.125 9.6875V8.5625C6.125 9.49437 7.63625 10.25 9.5 10.25C11.3638 10.25 12.875 9.49437 12.875 8.5625ZM6.125 10.4375C6.125 11.3694 7.63625 12.125 9.5 12.125C11.3638 12.125 12.875 11.3694 12.875 10.4375V11.5625C12.875 12.4944 11.3638 13.25 9.5 13.25C7.63625 13.25 6.125 12.4944 6.125 11.5625V10.4375ZM9.5 9.5C7.63625 9.5 6.125 8.74437 6.125 7.8125C6.125 6.88063 7.63625 6.125 9.5 6.125C11.3638 6.125 12.875 6.88063 12.875 7.8125C12.875 8.74437 11.3638 9.5 9.5 9.5Z"
          fill="#03292E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_5497">
          <rect width="9" height="9" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
